"use strict";
exports.__esModule = true;
exports.chart_line_data_Fill = {
  "name": "--pf-chart-line--data--Fill",
  "value": "transparent",
  "var": "var(--pf-chart-line--data--Fill, transparent)"
};
exports["default"] = exports.chart_line_data_Fill;